'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _storage = require('../storage');

var _storage2 = _interopRequireDefault(_storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var agentNameKey = 'agentName';
var agentIdKey = 'agentId';
var agentImagesUrlPrefix = 'https://img1.wsimg.com/liveengage/v2/agent/';

function setAgentInfo(agentInfo) {
  if (agentInfo && agentInfo.id && agentInfo.name) {
    _storage2.default.setItem(agentNameKey, agentInfo.name);
    _storage2.default.setItem(agentIdKey, agentInfo.id);
  }
}

function getAgentName() {
  return _storage2.default.getItem(agentNameKey);
}

function getAgentImage() {
  var id = _storage2.default.getItem(agentIdKey);
  return '' + agentImagesUrlPrefix + id + '.png';
}

exports.default = {
  setAgentInfo: setAgentInfo,
  getAgentImage: getAgentImage,
  getAgentName: getAgentName
};